// src/KeycodeInput.js
import React, { useState } from 'react';
import { db } from './firebaseConfig';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { Container, Card, Form, Button, Alert, Spinner } from 'react-bootstrap';

const KeycodeInput = ({ user }) => {
    const [newKeycode, setNewKeycode] = useState('');
    const [inputMessage, setInputMessage] = useState('');
    const [inputError, setInputError] = useState('');
    const [loading, setLoading] = useState(false);

    const handleAddKeycode = async (e) => {
        e.preventDefault();
        if (!user) {
            setInputError("Please log in to add keycodes.");
            return;
        }
        if (!newKeycode.trim()) {
            setInputError("Keycode cannot be empty.");
            return;
        }

        setInputMessage('');
        setInputError('');
        setLoading(true);

        try {
            await addDoc(collection(db, 'keycodes'), {
                code: newKeycode.trim(),
                used: false,
                addedBy: user.email || user.uid,
                timestamp: serverTimestamp(),
            });
            setInputMessage(`Koodi "${newKeycode}" Lisätty!`);
            setNewKeycode('');
        } catch (error) {
            console.error("Error adding keycode:", error);
            if (error.code === 'permission-denied') {
                setInputError("Permission Denied: You do not have permission to add keycodes. Check security rules.");
            } else {
                setInputError(`Failed to add keycode: ${error.message}`);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <Container className="my-4">
            <Card className="p-4 shadow-sm">
                <Card.Body className="text-center">
                    <Card.Title className="mb-3">Lisää uusia koodeja</Card.Title>
                    {!user && <Alert variant="info" className="mb-3">Kirjaudupa sisään.</Alert>}
                    <Form onSubmit={handleAddKeycode}>
                        <Form.Group className="mb-3" controlId="formNewKeycode">
                            <Form.Control
                                type="text"
                                placeholder="Syötä koodi"
                                value={newKeycode}
                                onChange={(e) => setNewKeycode(e.target.value)}
                                disabled={!user || loading}
                            />
                        </Form.Group>
                        <Button
                            variant="primary"
                            type="submit"
                            disabled={!user || loading}
                        >
                            {loading ? (
                                <>
                                    <Spinner
                                        as="span"
                                        animation="border"
                                        size="sm"
                                        role="status"
                                        aria-hidden="true"
                                    />{' '}
                                    Lisätään...
                                </>
                            ) : (
                                'Lisää'
                            )}
                        </Button>
                    </Form>
                    {inputMessage && <Alert variant="success" className="mt-3">{inputMessage}</Alert>}
                    {inputError && <Alert variant="danger" className="mt-3">{inputError}</Alert>}
                </Card.Body>
            </Card>
        </Container>
    );
};

export default KeycodeInput;